import { useState, useEffect, useMemo } from 'react';
import { FIXTURES, ProgrammeFilterEnums, RESULTS } from '../constants/programmeStatus';
import { IBasketballConfig } from '../types';

interface IUsePillsArgs {
  selectedPillTab: string;
  setSelectedPillTab: (value: string) => void;
  isFetching: boolean;
  hasFixtures?: boolean;
  hasResults?: boolean;
  dataLabels?: IBasketballConfig['dataLabels'];
}

export const useTabsController = ({
  selectedPillTab,
  setSelectedPillTab,
  hasFixtures,
  hasResults,
  isFetching,
  dataLabels,
}: IUsePillsArgs) => {
  const [isFixturesDisabled, setIsFixturesDisabled] = useState(false);
  const [isResultsDisabled, setIsResultsDisabled] = useState(false);

  useEffect(() => {
    if (!isFetching) {
      const noFixtures = hasFixtures === false;
      const noResults = hasResults === false;

      // Handle case where both are false - default to fixtures
      if (noFixtures && noResults) {
        setSelectedPillTab(FIXTURES);
        setIsFixturesDisabled(false);
        setIsResultsDisabled(true);
        return;
      }

      // Handle other cases
      if (selectedPillTab === FIXTURES && noFixtures) {
        setSelectedPillTab(RESULTS);
        setIsFixturesDisabled(true);
        setIsResultsDisabled(false);
      } else if (selectedPillTab === RESULTS && noResults) {
        setSelectedPillTab(FIXTURES);
        setIsResultsDisabled(true);
        setIsFixturesDisabled(false);
      } else {
        setIsFixturesDisabled(noFixtures);
        setIsResultsDisabled(noResults);
      }
    }
  }, [isFetching, selectedPillTab, hasFixtures, hasResults, setSelectedPillTab]);

  const pillTabOptions = useMemo(
    () => [
      { label: dataLabels?.fixtures || ProgrammeFilterEnums.FIXTURES, value: FIXTURES, isDisabled: isFixturesDisabled },
      { label: dataLabels?.results || ProgrammeFilterEnums.RESULTS, value: RESULTS, isDisabled: isResultsDisabled },
    ],
    [dataLabels, isFixturesDisabled, isResultsDisabled],
  );

  return { pillTabOptions };
};
